import { render, staticRenderFns } from "./QuizQuestionMediaContent.vue?vue&type=template&id=34a761aa&"
import script from "./QuizQuestionMediaContent.vue?vue&type=script&lang=js&"
export * from "./QuizQuestionMediaContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports